import getPercentOfTimeInDay from '../../utils/getPercentOfTimeInDay';
import { find } from 'lodash';
import { isToday, isSameDay } from '../../utils/date/date';

export const serializeManager = manager => ({
  avatarUrl: manager.avatar_url,
  email: manager.email,
  id: String(manager.id),
  name: manager.full_name.trim(),
  phone: manager.sip_extension,
  title: manager.full_name,
  value: String(manager.id),
});

export const sortManagers = managers => {
  if (!managers || managers.length <= 0) return null;

  return managers.sort(({ name: nameA }, { name: nameB }) =>
    nameA.localeCompare(nameB)
  );
};

export const serializeManagers = managers =>
  managers.map(manager => serializeManager(manager));

export const serializeManagerStatusHistory = (
  list,
  managerStatuses,
  selectedDateStr
) => {
  if (!list || !list.length) return [];

  const todayDate = new Date();
  const selectedDate = new Date(selectedDateStr);

  if (selectedDate > todayDate) return [];

  return list.reduce(
    (
      prev,
      { color, new_status: title, changed_at: startedAt, ended_at: finishedAt }
    ) => {
      let startedAtDate = new Date(startedAt);
      let finishedAtDate = new Date(finishedAt);

      if (!isSameDay(finishedAtDate, selectedDate)) {
        const modifiedDate = new Date(startedAtDate.getTime());
        modifiedDate.setHours(23, 59, 59, 999);
        finishedAt = isToday(startedAtDate) ? new Date() : modifiedDate;
      }

      finishedAtDate = new Date(finishedAt);

      if (!isSameDay(startedAtDate, selectedDate)) {
        const modifiedDate = new Date(finishedAtDate.getTime());
        modifiedDate.setHours(0, 0, 0, 0);
        startedAtDate = modifiedDate;
      }

      return [
        ...prev,
        {
          status: find(managerStatuses, { title }) || { title, color },
          startedAt: startedAtDate,
          endAt: finishedAtDate,
          startPercent: getPercentOfTimeInDay(startedAtDate),
          endPercent: getPercentOfTimeInDay(finishedAtDate),
        },
      ];
    },
    []
  );
};

export const serializeManagerHistoriesMap = ({
  histories,
  managerStatuses,
  selectedDate,
}) => {
  if (!histories || !histories.length) return {};

  return histories.reduce(
    (prev, { manager_id: managerId, status_history: statusHistory }) => ({
      ...prev,
      [managerId]: serializeManagerStatusHistory(
        statusHistory,
        managerStatuses,
        selectedDate
      ),
    }),
    {}
  );
};

export const serializeManagerCountsMap = statistic => {
  if (!statistic || !statistic.length) return {};

  return statistic.reduce(
    (
      prev,
      {
        manager_id: managerId,
        emails_count: emailsCount,
        messages_count: messagesCount,
      }
    ) => ({
      ...prev,
      [managerId]: {
        emails: emailsCount || 0,
        messages: messagesCount || 0,
      },
    }),
    {}
  );
};

export const serializeManagerStatusTimesMap = statistic => {
  if (!statistic || !statistic.length) return {};

  return statistic.reduce(
    (
      prev,
      {
        manager_id: managerId,
        time_in_offline: offlineTime,
        time_in_active_statuses: activeTime,
      }
    ) => ({
      ...prev,
      [managerId]: {
        offline: offlineTime || 0,
        active: activeTime || 0,
      },
    }),
    {}
  );
};

export const serializeSelectedManagersMap = ({
  managers,
  selectedManagers,
}) => {
  if (!selectedManagers || !selectedManagers.length) return {};

  return selectedManagers.reduce(
    (prev, managerId) => ({
      ...prev,
      [managerId]: find(managers, { id: String(managerId) }),
    }),
    {}
  );
};
